import { put } from 'redux-saga/effects';
import { setLeaderboardFilter } from '../actions';

/**
 * @typedef {object} UpdateLeaderboardFilterAction
 * @property {string} type
 * @property {object} payload
 * @property {string} payload.query
 */

/**
 * @param {UpdateLeaderboardFilterAction} action - The Redux action.
 */
export function* updateLeaderboardFilter(action) {
    yield put(setLeaderboardFilter(action.payload));
}
